<template>
  <div class="bg-gray">
    <div class="form-content">

      <el-form
          ref="ruleForm"
          label-width="260px"
          class="demo-ruleForm"
      > 
        <van-notice-bar style="font-weight: bold"
          v-if="row.saiqu.is_jiesong==1"  >
          此项费用包含: 车站到酒店的接送站费用、住宿费、餐费及赛场到酒店的接驳费（如涉及）。
        </van-notice-bar>
        <van-notice-bar style="font-weight: bold"
          v-if="row.saiqu.is_jiesong==2"  >
          本次比赛不提供接送站服务，此项费用包含: 住宿费、餐费及赛场到酒店的接驳费（如涉及）。
        </van-notice-bar>
 
        <el-divider>确认信息</el-divider>

        <el-row :gutter="20">
          <el-col :span="12" :key="rindex" v-for="(room,rindex) in orderData.list">
            <el-form-item :label="room.name" prop="name"> 
                <el-input-number v-model="room.count" @change="countChange" :min="0" :max="1000"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="额外食宿费用" prop="name"> 
                    <el-input v-model="row.shisu_fix" @input="countChange"  type="number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="食宿费用" prop="name">
              {{ orderData.price }}元
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="食宿人数" prop="name">
              {{ sai_member_count }}
            </el-form-item>
          </el-col>  
          <el-col :span="12">
            <el-form-item label="可入住人数" prop="name">
              {{ orderData.count }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="备注" prop="name">
              <el-input
                  type="textarea"
                  placeholder="您的食宿特殊要求？"
                  v-model="row.shisu_note"
              ></el-input>
            </el-form-item> -->
          </el-col>

        </el-row>
        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">保存
            </el-button>
            <el-button @click="resetForm('ruleForm')" plain v-if="false">重置</el-button>
          </el-col>
        </el-row>
      </el-form>

      <van-popup v-model="showRoomTypePicker" position="bottom">
        <van-picker :columns="row.room_type"
                    show-toolbar
                    value-key="name"
                    :default-index="0"
                    @cancel="showRoomTypePicker = false"
                    @confirm="onRoomTypeConfirm"
        />
      </van-popup>

    </div>
  </div>
</template>
<style scoped>
.form-content /deep/ .el-input{
  width: auto !important;
}
</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import SaiRoomMemberPicker from '@/components/picker/SaiRoomMemberPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep4',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
    SaiRoomMemberPicker,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      subjectName: '',
      subjectArray: [],
      subjectOptions: [],
      subjectOptionsAll: [
        {
          name: '幼儿组',
          children: [
            {
              name: '幼儿组',
              children: [{
                name: '舞蹈啦啦操',
                children: [
                  {
                    name: '花球规定动作',
                  },
                  {
                    name: '222',
                  }
                ]
              }, {
                name: '余杭区',
                children: [
                  {
                    name: '111',
                  },
                  {
                    name: '222',
                  }
                ]
              }],
            },
            {
              name: '温州',
              children: [{name: '鹿城区'}, {name: '瓯海区'}],
            },
          ],
        },
        {
          name: '福建',
          children: [
            {
              name: '福州',
              children: [{name: '鼓楼区'}, {name: '台江区'}],
            },
            {
              name: '厦门',
              children: [{name: '思明区'}, {name: '海沧区'}],
            },
          ],
        },
      ],
      row: {
        saiqu:{},
        room_list: [],
        member_list: [],
        room_type: [],
        shisu_note: '',
        shisu_fix:0,
      },
      formData: {
        id: 0,
        saiqu_name: 'xxxxx',
        danwei: 'xxxxx',
        caipan: [],
        music: [],
        famliy: [],
        tbydy: [],
        jiaolian: [],
        member: [],
        areas: '',
        province: '',
        city: '',
        county: '',
        kaojitype: '考级中心',
        changdipic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }],
        zhizhaopic: [{
          "uid": "vc-upload-1587109262602680",
          "url": "https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg",
          "name": "支付宝.jpg",
          "save_name": "h5/2020-04-17/1587109262602680.jpg"
        }], 
      },
        orderData:{
            list:[],
            price:0,
            count:0, 
        },
        sai_member_count:0,
        sui_member_count:0,
    }
  },
  filters: {
    sexName(val) {
      return val == 1 ? '男' : '女';
    },
    typeName(val) {
      switch (val) {
        case 1:
          return '领队';
          break;
        case 2:
          return '运动员';
          break;
        case 3:
          return '教练员';
          break;
        case 4:
          return '裁判员';
          break;
        default:
          return '随行人员'
      }
    }
  },
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
     document.title = '住宿信息';
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  computed: {
    orderData2() {
      let list = [];
      let price = 0;
      let count = 0;
      let that = this;
      this.row.room_type.map((roomType) => {
        let roomTypeRow = {
          name: roomType.name,
          price: roomType.price,
          count: 0
        }
        that.row.room_list.map((room) => {
          if (room.room_id == roomType.id) {
            roomTypeRow.count++;
            count += room.member.length
          }
        });
        list.push(roomTypeRow);
      });
      list.map((rvalue) => {
        price += rvalue.price * rvalue.count;
      });
      return {
        list: list,
        price: price,
        count: count
      }
    },
    memberOptions() {
      console.log('memberOptions');
      let option = this.row.member_list;
      let selectMember = [];
      this.row.room_list.map((room) => {
        if (room.edit == false) {
          selectMember = selectMember.concat(room.member);
        }
      });
      let foption = option.filter((om) => {
        let nosearch = true;
        selectMember.map((sm) => {
          if (sm.num == om.num) {
            //搜索存在num
            nosearch = false;
          }
        });
        return nosearch;
      })

      return foption;
    },
    memberLimit() {
      if (this.row.room_list.length == 0) {
        return 0;
      }
      return this.row.room_list[this.row.room_list.length - 1].limit;
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onRoomChange(value) {
      console.log('onRoomChange', value)
      this.row.room_list[this.row.room_list.length-1].name = value.name;
      this.row.room_list[this.row.room_list.length-1].room_id = value.id;
      this.row.room_list[this.row.room_list.length-1].limit = value.limit;
      this.row.room_list[this.row.room_list.length-1].price = value.price;
      this.row.room_list[this.row.room_list.length-1].member = [];
      // this.showRoomTypePicker = false;
    }, 
    onMemberConfirm(values) {
      console.log('onMemberConfirm', values)
      this.showMemberPicker = false;
      this.row.room_list[this.row.room_list.length - 1].member = [...values];
    },
    onMemberChange(values) {
      console.log('onMemberChange', values)
      this.row.room_list[this.row.room_list.length - 1].member = [...values];
    },
    roomAdd() {
      if (this.row.room_list.length > 0 && this.row.room_list[this.row.room_list.length - 1].edit) {
        return;
      }
      this.row.room_list.push({
        name: '',
        room_id: '',
        limit: 0,
        price: 0,
        member: [],
        edit: true
      })
    },
    roomSave() {
      if (this.row.room_list.length == 0 || !this.row.room_list[this.row.room_list.length - 1].edit) {
        return;
      }
      if (!this.row.room_list[this.row.room_list.length - 1].name) {
        this.$message.info('请选择房型');
        return;
      }
      if (this.row.room_list[this.row.room_list.length - 1].member.length == 0) {
        this.$message.info('请选择人员');
        return;
      }
      this.row.room_list[this.row.room_list.length - 1].edit = false;
    },
    roomRemove(index) {
      console.log('roomRemove');
      if (this.row.room_list.length == 0) {
        return;
      }
      this.row.room_list.splice(index, 1);
    },
    onRoomTypeConfirm(value, index) {
      this.row.room_list[this.row.room_list.length - 1].name = value.name;
      this.row.room_list[this.row.room_list.length - 1].room_id = value.id;
      this.row.room_list[this.row.room_list.length - 1].limit = value.limit;
      this.row.room_list[this.row.room_list.length - 1].price = value.price;
      this.row.room_list[this.row.room_list.length - 1].member = [];
      this.showRoomTypePicker = false;
    },

    submitForm(status) {
      const that = this; 
      console.log(that.formData)
      that.formValidate = true; 
      let inmember = 0// 已入住人数
      that.orderData.list.map(item =>{
          inmember+=item.limit*item.count
      })
      if(this.sai_member_count>inmember){
          // Toast.fail('还有'+(yundongyuanCount-inmember)+'位运动员没有分配好房间');
          // this.$message.info('还有'+(this.sai_member_count-inmember)+'位人员没有分配好房间');
          // return false;
      }
      that.saveLoading = true;
      that.$api.post('/api/sai/shisuSaveadmin', {
        id: that.row.id,
        list: JSON.stringify(that.row.room_list),
        shisu_fix :that.row.shisu_fix,
        shisu_note: that.row.shisu_note
      }, (res) => { 
        this.$message.success('保存成功');
        that.saveLoading = false;
      }, (res) => {
        that.$message.error(res.msg);
        that.saveLoading = false;
      })
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);
      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      let inmember = 0// 已入住人数
      that.orderData.list.map(item =>{
          inmember+=item.limit*item.count
      })
      // let yundongyuanCount = that.row.yundongyuan_shisu_count
      // console.log('yundongyuanCount',yundongyuanCount)
      console.log('inmember',inmember)
      if(this.sai_member_count>inmember){
          // Toast.fail('还有'+(yundongyuanCount-inmember)+'位运动员没有分配好房间');
          Toast.fail('还有'+(this.sai_member_count-inmember)+'位人员没有分配好房间');
          return false;
      }
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/sai/shisuSaveadmin', {
        id: that.row.id,
        list: JSON.stringify(that.row.room_list),
        shisu_note: that.row.shisu_note
      }, (res) => {

        rbLink({
          name: 'ISaiApplyDetail',
          query: {
            id: that.row.id
          }
        }, 'back')
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    countChange(){
        let that = this;
        that.row.room_list = [];
        that.orderData.count = 0; 
        that.orderData.price = parseInt(that.row.shisu_fix);
        that.orderData.list.map(item =>{
            console.log('item',item)
            that.orderData.count += item.limit*item.count;
            that.orderData.price += item.price*item.count*that.row.days;
            for(let i=0; i< item.count ; i++){
                that.row.room_list.push({
                    name:item.name,
                    room_id:item.id,
                    limit:item.limit,
                    price:item.price,
                    member:[],
                    saiji:that.row.saiji,
                    saiqu:that.row.saiqu,
                    user_id:that.row.user_id,
                    baoming_id:that.row.id,
                })
            }
        });
        console.log('that.row.room_list',that.row.room_list)
    },
    fetch() {
      let that = this;
      that.$api.post('/api/sai/step4detailadmin', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;
         
        that.orderData.price = that.row.shisu_fix;
        that.orderData.count = 0;
        that.orderData.list = that.row.room_type;
        that.orderData.list.map(item =>{ 
            that.$set(item,'count',0); 
            item.count = 0;
        });
        that.row.room_list.map(room=>{
            that.$set(room,'edit',false); 
            that.orderData.list.map(item =>{
                if(item.id == room.room_id){
                    item.count ++;
                }
            })
        }) 

        that.orderData.list.map(item =>{
            that.orderData.count += item.limit*item.count;
            that.orderData.price += item.price*item.count*that.row.days; 
        });
        
        that.sai_member_count = that.row.jiaolian_shisu_count+that.row.yundongyuan_shisu_count+that.row.suixing_shisu_count+that.row.lingdui_shisu_count;
        that.sui_member_count =  that.row.suixing_shisu_count
      }, (res) => {
        Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep4Admin.vue?66f9fcd6